import React from "react"
import HomeUI from "../../ui/homeUI/_index";

const OnLeavePage = () => {
  return <>
    <HomeUI />
  </>
}

export default OnLeavePage